var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDivisionBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 5.94238L6.55522 9.29403C6.61773 9.33012 6.68328 9.35619 6.75 9.37273V15.8731L1.16403 12.5673C0.907403 12.4154 0.75 12.1394 0.75 11.8412V5.94238ZM14.25 5.85327V11.8412C14.25 12.1394 14.0926 12.4154 13.836 12.5673L8.25 15.8731V9.31578C8.26361 9.30898 8.2771 9.30173 8.29045 9.29402L14.25 5.85327Z",
    fill: "#1CCAB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499209,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.932373 4.31562C1.00328 4.22607 1.09278 4.15039 1.19713 4.09482L7.10338 0.94902C7.35132 0.816961 7.64873 0.816961 7.89667 0.94902L13.8029 4.09482C13.8834 4.13766 13.955 4.19245 14.016 4.25632L7.54047 7.995C7.49789 8.01958 7.45864 8.04771 7.42286 8.07879C7.38708 8.04771 7.34782 8.01958 7.30524 7.995L0.932373 4.31562Z",
    fill: "#1CCAB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivisionBox);
export default __webpack_public_path__ + "static/media/divisionBox.a389419ba16afc6ab365ac728b1b10ca.svg";
export { ForwardRef as ReactComponent };